import { useParams } from 'react-router-dom';
import { GenerateTestDataButton } from './GenerateTestDataButton';
import { generatePaymentProfilesTestData } from '../utils/paymentProfilesTestDataGenerator';

export const GeneratePaymentProfilesButton = () => {
    const { id: customerId } = useParams();
    const generateFunction = (count: number) => generatePaymentProfilesTestData(count, customerId);

    return (
        <GenerateTestDataButton
            label="Generate Test Data"
            generateFunction={generateFunction}
            queryKey={['payment-profiles']}
        />
    );
};